import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { EventTabsService } from './event-tabs.service';

export const Ng1EventTabsModule = angular
  .module('control-room.shared.services.eventTabs', [])
  .factory('crEventTabsService', downgradeInjectable(EventTabsService));